import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var priceSchema = {
    date: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            dateFormat: "yy-mm-dd",
        }),
        elementType: 'datepicker',
        label: 'Дата',
        value: '',
        validation: {
            required: true
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете дата',
    }),
    time: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Време',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна стойност',
    }),
};
export default priceSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/priceSchema.ts
// module id = 548
// module chunks = 0